{
    "TREE": {
        "1...2": "tree/tree00",
        "3...4": "tree/tree01",
        "5...9": "tree/tree02",
        "10...14": "tree/tree03",
        "15...19": "tree/tree04",
        "20...24": "tree/tree05",
        "25...29": "tree/tree06",
        "30...34": "tree/tree07",
        "35...1000000": "tree/tree08"
    },
    "CANDLE": {
        "1...4": "candle/candle00",
        "5...9": "candle/candle01",
        "10...19": "candle/candle02",
        "20...39": "candle/candle03",
        "40...640000": "candle/candle04"
    },
    "TREE_API": {
        "1...2": "Tree 1",
        "3...4": "Tree 2",
        "5...9": "Tree 3",
        "10...14": "Tree 4",
        "15...19": "Tree 5",
        "20...24": "Tree 6",
        "25...29": "Tree 7",
        "30...34": "Tree 8",
        "35...1000000": "Tree 9"
    },
    "CANDLE_API": {
        "1...4": "Skull 1",
        "5...9": "Skull 2",
        "10...19": "Skull 3",
        "20...39": "Skull 4",
        "40...640000": "Skull 5"
    }
}